import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {PaqueteSeguros} from '../_models/paquete-seguros';
import {GarantiasIdoneas} from '../_models/garantias-idoneas';
import {GarantiasIdoneasDestino} from '../_models/garantias-idoneas-destino';
import {GarantiasIdoneasMunicipio} from '../_models/garantias-idoneas-municipio';
import {GarantiasIdoneasActividades} from '../_models/garantias-idoneas-actividades';
import {SegmentoActividad} from '../_models/segmento-actividad';
import {Observable} from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class GarantiaIdoneasActividadesService{
  private rutServicio = AppSettings.rutServiciosAPL + '/api/garantiasIdoneasActividadesEconomicas';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as GarantiasIdoneasActividades[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as GarantiasIdoneasActividades[] ) );
  }

  listadoPorActividades(id: string) {
    return this.httClient.get( this.rutServicio + '/garantiaIdonea/' + id ).pipe( map( res => res as GarantiasIdoneasActividades[] ) );
  }

  listadoPorActividadesActiva(id: string) {
    return this.httClient.get( this.rutServicio + '/garantiaIdonea/' + id + '/enabled').pipe( map( res => res as GarantiasIdoneasActividades[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as GarantiasIdoneasActividades ) );
  }

  crear( regCrear: GarantiasIdoneasActividades ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as GarantiasIdoneasActividades ) );
  }

  actualizar( regActualizar: GarantiasIdoneasActividades ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( segmentoActividades: GarantiasIdoneasActividades[] ): Observable<GarantiasIdoneasActividades[]> {
    segmentoActividades.map( sa => {
      sa.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', segmentoActividades ).pipe( map( res => res as GarantiasIdoneasActividades[] ) );
  }
}
